import React, { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { useSelector } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

import router from "./routes/routes";
import { theme } from "./theme/theme";

import MuiToastProvider from "./Components/MuiToastProvider";
import { AnimatedToastProvider } from "./Components/AnimatedToastProvider";

const NotificationListener = React.lazy(
  () => import("./Components/NotificationListener"),
);
const JobSubscriptionListener = React.lazy(
  () => import("./Components/JobSubscriptionListener"),
);

export default function App() {
  const token = useSelector((state) => state.userSlice?.token);

  useEffect(() => {
    if (!token) return;

    let cleanup = () => {};

    Promise.all([
      import("./utils/socket"),
      import("./utils/SocketChat"),
    ]).then(([notifSocket, chatSocket]) => {
      notifSocket.connectSocket(token);
      chatSocket.connectSocket(token);

      const disableSocketDebug = import.meta.env.DEV
        ? chatSocket.enableSocketDebug()
        : () => {};

      cleanup = () => {
        disableSocketDebug();
        notifSocket.disconnectSocket();
        chatSocket.disconnectSocket();
      };
    });

    return () => cleanup();
  }, [token]);
console.log("version 2 date 07/20 , 12:30")
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MuiToastProvider>
          <AnimatedToastProvider>
            {Boolean(token) && (
              <React.Suspense fallback={null}>
                <NotificationListener />
                <JobSubscriptionListener />
              </React.Suspense>
            )}
            <RouterProvider router={router} />
          </AnimatedToastProvider>
        </MuiToastProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}
